import {ACTIONS} from '../../actions/location.actions';
import {idMap} from '../../util/idMap';

const initialState = {
  fetchInProgress: false,
  featchError: '',
  locations: {}
}

export default (state = initialState,action) => {

  switch(action.type){

    case ACTIONS.LocationsLoading: {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        locations: {}
      };
    }

    case ACTIONS.LocationsError: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: action.payload,
        locations: {}
      };
    }

    case ACTIONS.LocationsCompleted: {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        locations: idMap(action.payload, '_id')
      }
    }

    case ACTIONS.LocationDetailsCompleted : {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        locations: {...state.locations, [action.payload._id]:action.payload}
      }
    }
    case ACTIONS.LocationTenderTypesLoading : {
      return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
        tenderTypes: []
      }
    }

    case ACTIONS.LocationTenderTypesError : {
      return {
        ...state,
        tenderTypes: []
      }
    }

    case ACTIONS.LocationTenderTypesCompleted : {
      return {
        ...state,
        tenderTypes: [...action.payload]
      }
    }

    case ACTIONS.LocationDetailsLoading : {
       return {
        ...state,
        fetchInProgress: true,
        fetchError: '',
      };
    }

    case ACTIONS.LocationDetailsError : {
       return {
        ...state,
        fetchInProgress: false,
        fetchError: action.payload,
      };
    }

    case ACTIONS.LocationPhotoUpdateCompleted:
    case ACTIONS.LocationPropertyUpdateCompleted:
    case ACTIONS.LocationUpdateTableCompleted : {
      return {
        ...state,
        fetchInProgress: false,
        fetchError: '',
        locations: {
          ...state.locations, 
          [action.payload.location]: locationReducer(state.locations[action.payload.location],action)}
      }
    }

    case ACTIONS.LocationActivationInProgress: {
      return {
        ...state,
        activationInProgress: true,
        fetchError: ''
      };
    }

    case ACTIONS.LocationActivationFailed: {
      return {
        ...state,
        activationInProgress: false,
        activationError: action.payload,
      };
    }

    case ACTIONS.LocationActivationCompleted: {
      return {
        ...state,
        activationInProgress: false,
        activationError: '',
        locations: {...state.locations, [action.payload._id]:action.payload}
      }
    }

    case ACTIONS.LocationAddCompleted: {
      return {
        locations: {...state.locations, [action.payload._id]:action.payload}
      }
      
    }

    default: 
      return state;
  }


};

function locationReducer(state, action) {

  switch(action.type){
    case ACTIONS.LocationPhotoUpdateCompleted: {
      return {
        ...state,
        [action.payload.photoProperty] : action.payload.url
      };
    }

    case ACTIONS.LocationPropertyUpdateCompleted: {
      return {
        ...state,
        ...action.payload.data
      }
    }

    case ACTIONS.LocationUpdateTableCompleted: {
      console.log("Location Reducer for 'LocationUpdateTableCompleted' being executed");
      return { 
        ...state, 
        tables: state.tables.map(t=>t._id === action.payload._id? tableReducer(t,action):t)
      };
    }
    default:
      return state;
  }

}

function tableReducer(state, action){
  switch(action.type){
    case ACTIONS.LocationUpdateTableCompleted: {
      console.log("Table Reducer for 'LocationUpdateTableCompleted' being executed");
      return {
        ...state,
        beaconId: action.payload.beaconId
      };
    }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/locations/index.js